/**
 * Application Configuration Constants
 * Centralized configuration for app-wide settings, theme defaults, and route paths
 */

// Internationalization
export const DEFAULT_LOCALE = "en";

// Theme Defaults
export const DEFAULT_THEME = {
  primaryColor: "#6699cc",
  secondaryColor: "#203b0e",
};

// Application Routes
export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  ADMIN: "/admin",
  PUBLISH: "/publish",
  USAGE: "/usage",
  SUITABILITY: "/suitability",
  LEGAL: "/legal",
  PRIVACY: "/privacy",
  SHORT_URL: "/s/:shortCode",
};

// Loading States
export const LOADING_MESSAGES = {
  ADMIN_ACCESS: "Verifying admin access...",
  PUBLISHER_ACCESS: "Verifying publisher access...",
};

// Toast Notification Configuration
// Desktop configuration (original working config)
export const TOAST_CONFIG_DESKTOP = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "light",
};

// Mobile toast configuration
// Uses top-center to avoid overlapping with bottom navigation
// Key changes: disabled pause behaviors, no close button
export const TOAST_CONFIG_MOBILE = {
  position: "top-center",
  autoClose: 7000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: false, // Don't pause when keyboard/app switching
  draggable: true,
  pauseOnHover: false, // Don't pause on tap - critical for mobile
  theme: "light",
  className: "toast-mobile",
  closeButton: false,
};

// Default configuration (backward compatibility)
export const TOAST_CONFIG = TOAST_CONFIG_DESKTOP;

export default {
  DEFAULT_LOCALE,
  DEFAULT_THEME,
  ROUTES,
  LOADING_MESSAGES,
  TOAST_CONFIG,
  TOAST_CONFIG_DESKTOP,
  TOAST_CONFIG_MOBILE,
};
